/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import featureFlags from './featureFlagState';

export const useFeatureFlag = (flagName) =>
{
    const [flagValue, setFlagValue] = useState(featureFlags.get(flagName));

    useEffect(() =>
    {
        let isMounted = true;

        const fetchFlagValue = async () =>
        {
            try
            {
                if (!featureFlags.getStatus())
                {
                    await featureFlags.init();
                }

                if (isMounted)
                {
                    const value = featureFlags.get(flagName);
                    setFlagValue(value);
                }
            }
            catch (error)
            {
                console.error('Optimizely SDK error: ', error);
            }
        };

        fetchFlagValue();

        return () =>
        {
            isMounted = false;
        };
    }, [flagName]);

    return flagValue;
};



export default useFeatureFlag;